import type { BubbleVariant } from '../constants'

export default function ConvBubble({
  name,
  role,
  tag,
  quote,
  variant,
}: {
  name: string
  role: string
  tag: string
  quote: string
  variant: BubbleVariant
}) {
  const isPurple = variant === 'purple'
  const orbGradient = isPurple
    ? 'radial-gradient(circle at 30% 30%, #c4b5fd, #7c3aed 55%, #3b0764)'
    : 'radial-gradient(circle at 30% 30%, #67e8f9, #06b6d4 55%, #164e63)'
  const orbShadow = isPurple
    ? '0 0 14px rgba(124,58,237,0.7), 0 0 4px rgba(196,181,253,0.4)'
    : '0 0 14px rgba(6,182,212,0.7), 0 0 4px rgba(103,232,249,0.4)'

  return (
    <div
      style={{
        background: 'rgba(255,255,255,0.06)',
        border: '1px solid rgba(255,255,255,0.14)',
        borderRadius: '22px',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.08)',
        padding: '18px 20px 20px',
      }}
    >
      <div
        style={{
          height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)',
          marginBottom: '14px',
        }}
      />
      <div className="flex items-center gap-3 mb-3">
        <div
          style={{
            width: '34px',
            height: '34px',
            borderRadius: '50%',
            background: orbGradient,
            boxShadow: orbShadow,
            position: 'relative',
            flexShrink: 0,
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '6px',
              left: '7px',
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.7)',
              filter: 'blur(1.5px)',
            }}
          />
        </div>
        <div className="min-w-0">
          <p className="font-headline font-semibold text-white text-sm leading-tight truncate">{name}</p>
          <p className="text-white/60 text-xs truncate">{role}</p>
        </div>
        <span
          className={`ml-auto shrink-0 text-[10px] font-headline font-bold uppercase tracking-wide px-2 py-0.5 rounded-full ${
            isPurple ? 'text-[#c4b5fd] bg-[#7c3aed]/15' : 'text-[#67e8f9] bg-[#06b6d4]/15'
          }`}
        >
          {tag === 'Professional' ? 'Pro' : 'Biz'}
        </span>
      </div>
      <p className="text-white/65 text-sm leading-relaxed italic">"{quote}"</p>
    </div>
  )
}
